import type { LucideProps } from "lucide-react";

import { cn } from "@/lib/utils";

import { Button } from "../ui/button";
import { Card } from "../ui/card";

export default function UserType({
	title,
	description,
	isChecked,
	Icon,
	toggleCheckbox
}: {
	title: string;
	description: string;
	isChecked: boolean;
	icon?: React.ElementType<LucideProps>;
	Icon: React.ComponentType<LucideProps>;
	toggleCheckbox: () => void;
}) {
	const formttedTitle = `${title.charAt(0).toUpperCase()}${title.replace("-", " ").slice(1)}`;
	return (
		<Card
			onClick={toggleCheckbox}
			className={cn("mx-auto rounded-3xl border p-6 max-w-md cursor-pointer", {
				"border-primary bg-primary/10": isChecked
			})}
		>
			<div className="flex items-center justify-between">
				<div className="rounded-full bg-primary/5 p-4">
					<Icon className="text-primary" />
				</div>
				<Button
					size="icon"
					variant="ghost"
					className="p-0 text-primary hover:bg-transparent"
					aria-checked={isChecked}
					role="checkbox"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="size-6"
					>
						<circle
							cx="12"
							cy="12"
							r="10"
							stroke="currentColor"
							strokeWidth="2"
						/>
						{isChecked && <circle cx="12" cy="12" r="6" fill="currentColor" />}
					</svg>
				</Button>
			</div>
			<div className="space-y-2">
				<h1 className="text-xl font-semibold text-gray-900">{formttedTitle}</h1>
				<p>{description}</p>
			</div>
		</Card>
	);
}
